// Importing necessary libraries and components
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import styles from "assets/jss/material-dashboard-react/components/businessForm";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { format, parseISO, subMonths } from "date-fns";
import { Checkbox } from "@material-ui/core";
import { createTheme } from "@material-ui/core";
import { MuiThemeProvider } from "@material-ui/core/styles";
import {
  getApiLogsDataFetchLogs,
  setFormDataApiLogs,
  clearFormDataApiLogs,
} from "../../Redux/Actions/merchantInformation";
import { getAutoDateRange, getDateRange, getDefaultDateRange, getFormattedDate, groupCheck, isDateRangeValid } from "../../Utils/commonUtils";

// Custom theme for Material-UI components
export const customTheme = createTheme({
  palette: {
    primary: {
      main: "#003c6e",
      light: "#003c6e",
      dark: "#003c6e",
    },
    secondary: {
      main: "#003c6e",
    },
  },
  overrides: {
    MuiPickersBasePicker: {
      container: {
        width: "300px",
        height: "370px",
      },
      pickerView: {
        width: "280px",
        height: "280px",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        fontSize: "0.9rem",
      },
      dayLabel: {
        fontSize: "0.7rem",
      },
    },
    MuiPickersDay: {
      day: {
        fontSize: "0.8rem",
      },
    },
    MuiTypography: {
      h4: {
        fontSize: "1rem",
      },
    },
  },
});

// Custom styles for the component
const useStyles = makeStyles(styles);
const searchButtonStyles = makeStyles((theme) => ({
  searchButton: {
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      boxShadow:
        "0 14px 26px -12px rgb(153 153 153 / 42%), 0 4px 23px 0px rgb(0 0 0 / 12%), 0 8px 10px -5px rgb(153 153 153 / 20%)",
    },
  },
}));

// Main component for API Logs Search
function ApiLogsSearchNew(props) {
  const classes = useStyles();
  const searchButtonClasses = searchButtonStyles();

  // State variables for form inputs
  const [showDateRange, setShowDateRange] = React.useState(true);
  const [showDateRangeError, setShowDateRangeError] = React.useState(false);
  const [date1, setDate1] = React.useState("");
  const [date2, setDate2] = React.useState("");
  const [apiType, setApiType] = React.useState("");
  const [apiTypeValue, setApiTypeValue] = React.useState("");
  const [module, setModule] = React.useState("");
  const [searchStatus, setSearchStatus] = React.useState("");
  const [requestedFor, setRequestedFor] = React.useState(null);
  const [moduleValue, setModuleValue] = React.useState("");
  const menu = JSON.parse(localStorage.getItem("menu"));
  const pathParts = window.location.pathname.split("/");
  const idFromUrl = pathParts[pathParts.length - 1];
  const { startDate, endDate } = getDefaultDateRange(idFromUrl);

  const [moduleOptions, setModuleOptions] = React.useState([]);
  const [apiTypeOptions, setApiTypeOptions] = React.useState([]);

  // Fetching module and API type options based on lookup data
  React.useEffect(() => {
    if (props.roles.lookupMasterData?.data?.length && idFromUrl) {
      const groupInfo = groupCheck[idFromUrl.toLowerCase()];

      if (groupInfo) {
        const moduleData = props.roles.lookupMasterData.data.find(
          (item) => item.Lookup_Code === groupInfo.Module
        );

        const apiTypeData = props.roles.lookupMasterData.data.find(
          (item) => item.Lookup_Code === groupInfo.APIType
        );
        setModuleOptions(moduleData?.LookUp_Detail);
        setApiTypeOptions(apiTypeData?.LookUp_Detail);

        // Do something with moduleData and apiTypeData here, e.g., set state
      }
    }
  }, [props.roles.lookupMasterData, idFromUrl]);
  const clearFormData = () => {
    const initialFormData = {
      searchRequestedFor: "",
      searchApiType: "",
      searchApiTypeValue: "",
      searchModule: "",
      searchModuleValue: "",
      searchResponseDate: "",
      searchStartDate: "",
      searchEndDate: "",
      searchStatus: null,
      searchStatusValue: "",
    };
    setRequestedFor("");
    setShowDateRange(false);
    setDate1("");
    setDate2("");
    props.setFormDataApiLogs(initialFormData);
  };

  const handleClose = () => {
    // const profileCode = menu?.Role_Permission_Data?.Profile_Code;
    // const payload = {
    //   Profile_Code: profileCode,
    //   exportToExcel: false,
    //   exportToPDF: false,
    //   pageNo: 1,
    //   groupName: idFromUrl,
    //   pageSize: 5,
    //   searchStartDate: startDate,
    //   searchEndDate: endDate,
    //   dateRange: showDateRange
    // };
    // props.getApiLogsDataFetchLogs(payload);
    props.clearFormDataApiLogs();
    clearFormData();
    props.clearChips();
  };

  const handleApiTypeChange = (value) => {
    const allModules = props.roles.lookupMasterData?.data || [];
    for (const module of allModules) {
      if (module.Lookup_Code.startsWith("APIType_")) {
        const detail = module.LookUp_Detail.find(
          (d) => d.Lookup_Detail_Name === value
        );
        if (detail) {
          setApiType(detail.Lookup_Detail_Code);
          setApiTypeValue(detail.Lookup_Detail_Name);
          break;
        }
      }
    }
  };

const handleSearchStartDateChange = (date) => {
  const formattedDate = getFormattedDate(date);
  if (!formattedDate) {
    return;
  }
  setDate1(formattedDate);
};

const handleSearchEndDateChange = (date) => {
  const formattedDate = getFormattedDate(date);
  if (!formattedDate) {
    return;
  }
  setDate2(formattedDate);
};
  
  
  const handleDateCheckboxChange = (event) => {
    const checked = event.target.checked;
    setShowDateRange(checked);
    if (checked) {
      const today = new Date();
      const maxDateRange = getDateRange(idFromUrl, "Months") ?? 2;
      const endDate = format(today, "yyyy-MM-dd");
      const startDate = format(subMonths(today, maxDateRange), "yyyy-MM-dd");

      setDate1(startDate);
      setDate2(endDate);
    } else {
      setDate1("");
      setDate2("");
    }
  };
  const handleModuleChange = (value) => {
    const allModules = props.roles.lookupMasterData?.data || [];

    for (const module of allModules) {
      if (module.Lookup_Code.startsWith("Module_")) {
        const detail = module.LookUp_Detail.find(
          (d) => d.Lookup_Detail_Name === value
        );
        if (detail) {
          setModule(detail.Lookup_Detail_Code); // e.g., "M_Invite_Page"
          setModuleValue(detail.Lookup_Detail_Name); // e.g., "Invite Page"
          break;
        }
      }
    }
  };

  

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === "searchApiType") {
      handleApiTypeChange(value);
    } else if (name === "searchModule") {
      handleModuleChange(value);
    }
  };

  const handleInputChange = (e) => {
    const { value } = e.target;

    if (value.length === 0) {
      // Allow clearing the input
      setRequestedFor(value);
      return;
    }

    const firstChar = value[0];

    if (Number.isNaN(Number(firstChar))) {
      // First character is a letter or other non-numeric
      if (/^[a-zA-Z]*$/.test(value)) {
        setRequestedFor(value);
      }
    } else if (/^\d*$/.test(value)) {
      // Value is all digits
      setRequestedFor(value);
    }
  };

  const handleStatusChange = (e) => {
    const { value } = e.target;
    setSearchStatus(value);
  };
  React.useEffect(() => {
    if (props.formData.searchRequestedFor) {
      setRequestedFor(props.formData.searchRequestedFor);
    }
    if (props.formData.searchApiType) {
      setApiType(props.formData.searchApiType);
    }
    if (props.formData.searchApiTypeValue) {
      setApiTypeValue(props.formData.searchApiTypeValue);
    }
    if (props.formData.searchModule) {
      setModule(props.formData.searchModule);
    }
    if (props.formData.searchModuleValue) {
      setModuleValue(props.formData.searchModuleValue);
    }
    if (props.formData.searchStatus) {
      setSearchStatus(props.formData.searchStatus);
    }
    if (props.formData.searchStartDate) {
      setDate1(props.formData.searchStartDate);
    }
    if (props.formData.searchEndDate) {
      setDate2(props.formData.searchEndDate);
    }
    if (props.formData.dateRange === false) {
      setShowDateRange(props.formData.dateRange);
    }
  }, [props.formData]);

  // Handle form submission
  const onFormSubmit = (event) => {
    event.preventDefault();
    if (showDateRange && date1 && date2) {
      const isValid = isDateRangeValid(date1, date2, idFromUrl);
      if (!isValid) {
        setShowDateRangeError(true);
        return;
      }
    }
    const nextFormData = {
      ...(props.formData || {}),
      searchRequestedFor: requestedFor || "",
      searchApiType: apiType || "",
      searchApiTypeValue: apiTypeValue || "",
      searchModule: module || "",
      searchModuleValue: moduleValue || "",
      searchStartDate: date1 || null,
      searchEndDate: date2 || date1 || null,
      searchStatus: searchStatus ? searchStatus.trim() : "",
      dateRange: showDateRange,
    };
    props.setFormDataApiLogs(nextFormData);
    const profileCode = menu?.Role_Permission_Data?.Profile_Code;
    const payload = {
      Profile_Code: profileCode,
      exportToExcel: false,
      exportToPDF: false,
      pageNo: 1,
      groupName: idFromUrl,
      pageSize: 5,
      sortColumn: props?.apiLogsData?.sortColumn,
      sortOrder: props?.apiLogsData?.sortOrder,
      // searchStartDate: date1,
      // searchEndDate: date2,
      searchRequestedFor: requestedFor || "",
      dateRange: showDateRange,
      searchApiType: apiType || "",
      searchModule: module || "",
      searchStartDate: date1 || "",
      searchEndDate: showDateRange ? date2 || "" : null,
      searchStatus: searchStatus ? searchStatus.trim() : "",
    };
    // props.getApiLogsDataFetchLogs(payload);
    props.seacrhChipData(payload);
    setShowDateRangeError(false);
    props.close();
  };

  return (
    <MuiThemeProvider theme={customTheme}>
      <form onSubmit={(e) => onFormSubmit(e)}>
        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  focused: "focused",
                  input: classes.resize,
                },
              }}
              label="Requested For"
              value={requestedFor}
              onChange={handleInputChange}
              name="searchRequestedFor"
              id="Requested For"
              style={{ fontSize: "82%" }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              placeholder="Select API Type"
              label="API Type"
              value={apiTypeValue || ""}
              onChange={onChange}
              name="searchApiType"
              id="searchApiType"
              select
              style={{ fontSize: "82%" }}
            >
              {apiTypeOptions.length > 0 ? (
                apiTypeOptions.map((item) => (
                  <MenuItem key={item._id} value={item.Lookup_Detail_Name}>
                    {item.Lookup_Detail_Name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Data Found</MenuItem>
              )}
            </TextField>
          </Grid>
        </Grid>
        {/* <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              placeholder="Select Module"
              label="Module"
              value={moduleValue || ""}
              onChange={onChange}
              name="searchModule"
              id="searchModule"
              select
              style={{ fontSize: "82%" }}
            >
              {moduleOptions.length > 0 ? (
                moduleOptions.map((item) => (
                  <MenuItem
                    key={item._id}
                    className={classes.dialogBoxDropDown}
                    value={item.Lookup_Detail_Name}
                  >
                    {item.Lookup_Detail_Name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No Data Found</MenuItem>
              )}
            </TextField>
          </Grid>
        </Grid> */}
        {/* <Grid container className={classes.margin} style={{ marginBottom: "5%" }} >
          <Grid item xs>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                autoOk
                variant="inline"
                label="Request Date"
                value={props.formData.searchRequestDate ? new Date(props.formData.searchRequestDate) : null}
                onChange={handleSearchStartDateChange}
                format="yyyy/MM/dd"
                maxDate={new Date()}
                className={`${classes.rootDialog}`}
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid> */}
        <Grid container className={classes.margin}>
          <Grid item xs container alignItems="center">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                autoOk
                variant="inline"
                label={showDateRange ? "From" : "Date"}
                value={date1 ? parseISO(date1) : null}
                onChange={handleSearchStartDateChange}
                format="yyyy/MM/dd"
                maxDate={new Date()}
                style={{
                  width: showDateRange ? "50%" : "100%",
                }}
              />

              {(inputProps) => (
                <TextField
                  {...inputProps}
                  className={classes.rootDialog}
                  InputLabelProps={{
                    classes: {
                      root: classes.activeInputLabelColor,
                      focused: "focused",
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.activeInputColor,
                      focused: "focused",
                      input: classes.resize,
                    },
                  }}
                  label={showDateRange ? "From" : "Date"}
                  style={{
                    width: showDateRange ? "50%" : "100%",
                    fontSize: "100%",
                  }}
                />
              )}
            </MuiPickersUtilsProvider>
            {showDateRange && (
              <>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <DatePicker
                    autoOk
                    variant="inline"
                    label="To"
                    value={date2 ? parseISO(date2) : null}
                    onChange={handleSearchEndDateChange}
                    format="yyyy/MM/dd"
                    maxDate={new Date()}
                    style={{
                      width: "50%",
                    }}
                  />
                  {(inputProps) => (
                    <TextField
                      {...inputProps}
                      className={classes.rootDialog}
                      InputLabelProps={{
                        classes: {
                          root: classes.activeInputLabelColor,
                          focused: "focused",
                        },
                      }}
                      InputProps={{
                        classes: {
                          root: classes.activeInputColor,
                          focused: "focused",
                          input: classes.resize,
                        },
                      }}
                      label="To"
                      style={{ width: "50%", fontSize: "82%" }}
                    />
                  )}
                </MuiPickersUtilsProvider>
              </>
            )}
            {showDateRange && showDateRangeError && (
              <span style={{ fontSize: "12px", color: "primary", fontStyle: "italic" }}>
                {`Only ${getDateRange(idFromUrl, "Months") ?? 2} months of date range allowed`}
              </span>
            )}
            <Checkbox
              checked={showDateRange}
              onChange={handleDateCheckboxChange}
              color="primary"
              style={{ marginLeft: "auto" }}
            />
            <label style={{ fontSize: "12px", marginBottom: 0 }}>
              Search In Range
            </label>
          </Grid>
        </Grid>
        <Grid
          container
          className={classes.margin}
          style={{ marginBottom: "5%" }}
        >
          <Grid item xs>
            <TextField
              className={classes.rootDialog}
              InputLabelProps={{
                classes: {
                  root: classes.activeInputLableColor,
                  focused: "focused",
                },
              }}
              InputProps={{
                classes: {
                  root: classes.activeInputColor,
                  input: classes.resize,
                  focused: "focused",
                },
              }}
              placeholder="Select Status"
              label="Status"
              value={searchStatus || ""}
              onChange={handleStatusChange}
              name="searchStatus"
              id="Current_Status"
              select
              style={{ fontSize: "82%" }}
            >
              <MenuItem className={classes.dialogBoxDropDown} value="Success">
                Success
              </MenuItem>
              <MenuItem className={classes.dialogBoxDropDown} value="Failure">
                Failure
              </MenuItem>
            </TextField>
          </Grid>
        </Grid>

        <Grid
          container
          className={classes.margin}
          style={{ justifyContent: "end" }}
        >
          <Button
            variant="contained"
            className={classes.clearButton}
            disabled={
              !requestedFor &&
              !apiTypeValue &&
              !moduleValue &&
              !searchStatus &&
              !date1 &&
              !date2
            }
            onClick={() => handleClose()}
          >
            clear
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={`${classes.buttonStyle} ${searchButtonClasses.searchButton}`}
            disabled={
              !requestedFor &&
              !apiTypeValue &&
              !moduleValue &&
              !searchStatus &&
              !date1 &&
              !date2
            }
            type="submit"
          >
            Search
          </Button>
        </Grid>
      </form>
    </MuiThemeProvider>
  );
}
// Prop types for the component
ApiLogsSearchNew.propTypes = {
  close: PropTypes.func,
  seacrhChipData: PropTypes.func,
  getApiLogsDataFetchLogs: PropTypes.func,
};
// Mapping Redux state to props
const mapStateToProps = (app) => ({
  formData: app.merchantInformation,
  tableData: app.provideRegistration,
  userDetails: app.app,
  roles: app.roles,
  apiLogsData: app.merchantInformation,
});
// Connecting the component to Redux
export default connect(mapStateToProps, {
  setFormDataApiLogs,
  clearFormDataApiLogs,
  getApiLogsDataFetchLogs,
})(ApiLogsSearchNew);
